import http from '@/services/http';

import events from '@/services/events';


// aka. sendStagedItemsToKitchen in order store;
async function addStagedItemsToOrder({ commit, dispatch, rootState, rootGetters }) {
  const ordersRootState = rootState.orders;

  const { orders, order } = ordersRootState;

  try {
    let { orderId } = order;

    if (!orderId) {
      await dispatch('getTableOrders');

      orderId = orders[0].orderId;

      commit('orders/SET_ORDER', orders[0], { root: true });
    }

    const campaignId = rootGetters['session/campaignId'];

    const items = order.orderItemsStaged.map((item) => {
      const modifiers = item.modifiers.map(modifier => ({
        menuItemId: modifier.menuItemId,
        quantity: modifier.quantity
      }));

      return {
        isUpsell: item.isUpsell,
        menuItemId: item.menuItemId,
        categoryId: item.categoryId,
        quantity: item.quantity,
        modifiers,
        ...(campaignId && { campaignId })
      };
    });

    const response = await http.post(`/cardfree-api/v1/oat/order/${orderId}/items`, items);

    const orderResponse = response.data.orders.find(o => o.orderId === orderId);

    await dispatch('orders/cacheOrderSelection', orderResponse, { root: true });

    const syncOrderPayload = { data: response.data };

    await dispatch('socket/syncOrdersAtTable', syncOrderPayload, { root: true });

    await dispatch('orders/updateStagedOrderItems', [], { root: true });

    const eventPayload = { type: 'success', message: 'Your order was submitted to the kitchen.' };

    events.emit('notification', eventPayload);
  }
  catch (error) {
    throw error;
  }
}

export { addStagedItemsToOrder };
